import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { wechatPayPC as _wechatPayPC, orderDetail } from '@/services/http';
import CountDown from '@/components/countdown/index.vue';
import QRCode from 'qrcodejs2';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 支付类型，1支付宝支付,2微信支付,
    _this.radio = 1;
    _this.totalPrice = '';
    _this.paytime = 0; // 订单支付倒计时时间
    _this.surplus = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      var _this2 = this;
      this.wechatPayPC();
      window.setInterval(function () {
        setTimeout(function () {
          _this2.getPayTime();
        }, 0);
      }, 1000);
    }
  }, {
    key: "wechatPayPC",
    value: function () {
      var _wechatPayPC2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, qrcode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _wechatPayPC({
                orderNo: this.$route.query.id,
                equip: '',
                version: ''
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                // eslint-disable-next-line no-unused-vars
                qrcode = new QRCode(this.$refs.qrCodeUrl, {
                  text: res.data.data.code_url,
                  width: 320,
                  height: 320,
                  colorDark: '#000000',
                  colorLight: '#ffffff',
                  correctLevel: QRCode.CorrectLevel.H
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function wechatPayPC() {
        return _wechatPayPC2.apply(this, arguments);
      }
      return wechatPayPC;
    }() //  获取支付倒计时时间
  }, {
    key: "getPayTime",
    value: function () {
      var _getPayTime = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              anchor = readCookie('anchor');
              _context2.next = 3;
              return orderDetail({
                orderNo: this.$route.query.id,
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : ''
              });
            case 3:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.paytime = Date.now() + Number(res.data.data.surplus) * 1000;
                this.surplus = +res.data.data.surplus;
                this.totalPrice = res.data.data.totalAmount;
                if (res.data.data.orderStatus === 1) {
                  window.location.href = "".concat(process.env.VUE_APP_BASE_API, "/payment-success?id=").concat(this.$route.query.id);
                }
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getPayTime() {
        return _getPayTime.apply(this, arguments);
      }
      return getPayTime;
    }()
  }, {
    key: "goBack",
    value: function goBack() {
      this.$router.back();
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    CountDown: CountDown
  }
})], default_1);
export default default_1;